<template>
    <v-modal :title="title" :cancelLabel="cancelLabel" @close="cancel">
        <template slot="content">
            {{ content }}
        </template>
        <template slot="actions">
            <r-button type="primary" :class="{'btn-danger' : dangerConfirm}" @click="confirm">{{confirmLabel}}</r-button>
        </template>
    </v-modal>
</template>

<script>
    import vModal from '@/components/modal/v-modal';

    export default {
        components: {
            vModal,
        },
        name: 'v-confirm',
        props: {
            title: {
                type: String,
                default: null,
            },
            content: {
                type: String,
                default: null,
            },
            confirmLabel: {
                type: String,
                default: 'Ok',
            },
            dangerConfirm: {
                type: Boolean,
                default: false,
            },
            cancelLabel: {
                type: String,
                default: 'Cancel',
            },
            cancel: {
                type: Function,
                default: () => {},
            },
            confirm: {
                type: Function,
                default: () => {},
            },
        },
    };
</script>
